import React, { useState, useEffect } from 'react';

interface ProgressBarProps {
  message: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ message }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Animate the progress bar to 100%
    const timer = setTimeout(() => setProgress(100), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full py-4">
      <p className="text-lg font-semibold text-gray-700 mb-3">{message}</p>
      <div className="w-full bg-brand-light-purple/30 rounded-full h-2.5">
        <div
          className="bg-brand-purple h-2.5 rounded-full transition-all duration-1000 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <p className="text-sm text-gray-500 mt-2">Loading jobs...</p>
    </div>
  );
};

export default ProgressBar;
